<ng-content select=".input-group-prepend"></ng-content>
@if (!formatterTemplate) {
  <select [(ngModel)]="selectedValue" (ngModelChange)="onModelChange()" [compareWith]="equalsFunction"
    [ngClass]="allClasses" [required]="required" [disabled]="disabled" [id]="id ? id + '-select' : ''"
    class="form-select rounded">
    @if (nullOption || placeholder) {
      <option [hidden]="!nullOption" [ngValue]="null">{{disabled ? '' : placeholder}}</option>
    }
    @for (option of _options; track option) {
      @if (!optionVisible || isVisible(option)) {
        <option [ngValue]="option" [disabled]="optionSelectable && isDisabled(option)">
          {{selectedValue === option ? selectedFormatter(option) : formatter(option)}}
        </option>
      }
    }
  </select>
} @else {
  <button class="form-select rounded text-start"
       [typeahead]="() => visibleOptions.asObservable()" 
       [resultFormatter]="input => input" 
       [inputFormatter]="input => input" 
       [resultTemplate]="formatterTemplate"
       (focus)="onFocus()"
       (click)="onClick()"
       (blur)="onBlur()"
       (selectItem)="onSelectOption($event)">
    <ng-container [ngTemplateOutlet]="formatterTemplate" [ngTemplateOutletContext]="{result: selectedValue}"></ng-container>
  </button>
}
<ng-content select=".invalid-feedback"></ng-content>
<ng-content select=".valid-feedback"></ng-content>
